import type { InternalAxiosRequestConfig } from 'axios';

/**
 * 요청 인터셉터 설정
 */
export const setupRequestInterceptor = () => {
  return {
    onFulfilled: (config: InternalAxiosRequestConfig) => {
      // 프로덕션 환경에서는 로깅 제거 또는 간소화
      if (import.meta.env.DEV) {
        console.debug('📤 [API Request] 요청 전송:', {
          url: config.url,
          method: config.method,
          withCredentials: config.withCredentials,
          hasCookies: document.cookie.length > 0,
          cookieCount: document.cookie.split(';').length,
        });
      }
      return config;
    },

    onRejected: (error: unknown) => {
      if (import.meta.env.DEV) {
        console.log('🔴 [API Request] 요청 에러:', error);
      }
      return Promise.reject(error);
    },
  };
};
